import DefaultGrid from "../../../components/DefaultGrid/DefaultGrid";
import { thresholdColumnDefs } from "./RiskStatusThresholdColumnDefs";
import { PaginationChangedEvent } from "ag-grid-community";
import { useCallback, useMemo, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { mockRiskCommodityThresholdData } from "./MockData";
const RiskStatusThresholdPage = () => {
  const gridRef = useRef<AgGridReact>(null);

  // TODO Replace with your actual API call and remove the mock data:
  //  useEffect(() => {
  // try {
  // const response = await fetch("/api/risk-status/default-threshold");
  // const data = await response.json();
  // const fetchDefaultThreshold = async () => { ...
  // setDefaultThreshold(data);
  // } catch (error) {
  //  }
  //};
  // fetchDefaultThreshold();
  // }, []);

  const mockedDefaultThresholdData = useMemo(
    () => ({
      commodity: "Default threshold",
      isDefaultValue: false,
      highRiskMin: "0.00",
      highRiskMax: "2.99",
      mediumRiskMin: "3.00",
      mediumRiskMax: "7.99",
      lowRiskMin: "8.00",
      lowRiskMax: "10.00",
    }),
    [],
  );

  //TODO: Replace with actual API call and remove this mock data.
  const mockData = useMemo(() => mockRiskCommodityThresholdData, []); // End of mockData useMemo

  // Handle pagination change to refresh grid layout
  const handlePaginationPageSizeChanged = useCallback(
    (event: PaginationChangedEvent) => {
      const api = event.api;
      setTimeout(() => {
        if (api) {
          api.refreshCells();
          api.redrawRows();
        }
      }, 0);
    },
    [],
  );

  return (
    <div className="flex flex-col items-center w-full min-h-screen bg-gray-50">
      <div className="mt-12 w-full px-6 md:px-12 lg:px-24 xl:px-32 2xl:px-48">
        <div className="border border-gray-300 rounded-sm shadow-sm bg-white">
          <div className="overflow-x-auto">
            <div className="min-w-[1250px]">
              <DefaultGrid
                ref={gridRef} // Add ref to grid
                rowId={(data: any) => data.commodity}
                columnDefs={thresholdColumnDefs}
                rowData={mockData}
                pinnedTopRowData={[mockedDefaultThresholdData]} // Pin the default threshold row
                onPaginationPageSizeChanged={handlePaginationPageSizeChanged}
                domLayout="autoHeight" // Change from "normal" to "autoHeight"
                getRowStyle={(params) => {
                  // Apply custom style for pinned top rows
                  // Back-compatibility: check for 'top' pinned rows
                  if (params.node.rowPinned === "top") {
                    return {
                      background: "#D8EFFA", // Light blue color for top pinned row
                      fontWeight: "500",
                    };
                  }
                  return undefined;
                }}
              />
            </div>
          </div>
        </div>
        <div className="mt-3 flex items-start gap-1 text-[13px] text-gray-700">
          <span className="text-[#005DA4] font-bold text-lg leading-none">
            ✱
          </span>
          <span>
            Indicated that the commodities are using the default values.
          </span>
        </div>
      </div>
    </div>
  );
};

export default RiskStatusThresholdPage;
